// src/utils/api.js
export const fetchWithAuth = async (url, options = {}) => {
  let token = localStorage.getItem('token');
  if (!token) {
    // If no token, redirect to login
    window.location.reload();
    return;
  }

  // Optionally fetch user IP if needed for headers
  let userIp = '';
  try {
    const ipResponse = await fetch('https://api.ipify.org?format=json');
    const responseIp = await ipResponse.json();
    userIp = responseIp['ip'];
  } catch {}

  let headers = {
    ...options.headers,
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
    ...(userIp ? { 'user-ip': userIp } : {}),
  };

  let response = await fetch(url, {
    ...options,
    headers,
    credentials: 'include', // Always include cookies for refresh
  });

  if (response.status === 401 || response.status === 403) {
    // Try to refresh token
    const refreshResp = await fetch('https://be-lb.chitragupta.co/refresh', {
      method: 'POST',
      credentials: 'include',
    });
    const refreshData = await refreshResp.json();
    if (refreshResp.ok && refreshData.accessToken) {
      localStorage.setItem('token', refreshData.accessToken);
      headers.Authorization = `Bearer ${refreshData.accessToken}`;
      response = await fetch(url, {
        ...options,
        headers,
        credentials: 'include',
      });
    } else {
      localStorage.removeItem('token');
      window.location.reload();
      return;
    }
  }
  return response;
};
  